import React from 'react'
import {
  FieldPath, FieldPathByValue, FieldValues,
} from 'react-hook-form'
import { TraderType } from 'features/declaration/models/schemas/tradersSchema'
import FormField from 'components/p5/FormField'
import FormSelect from 'components/p5/FormSelect'
import { TYPE_OF_PERSON_OPTIONS } from 'features/declaration/models/declarationOptions'
import DotLeafPaths from 'helpers/dot-leaf-paths'
import { FieldRule } from 'features/declaration/models/fieldRules'

type TraderRelPath = DotLeafPaths<TraderType>

type TraderBasePath<TForm extends FieldValues> = FieldPathByValue<TForm, TraderType | null | undefined>

function TypeOfPerson<TForm extends FieldValues>({
  scope,
  fieldRule,
}: Readonly<{
  scope: TraderBasePath<TForm>
  fieldRule?: FieldRule
}>) {
  const field = (rel: TraderRelPath) => `${scope}.${rel}` as FieldPath<TForm>

  return (
    <FormField labelKey="declaration.p5.typeOfPerson" fieldRule={fieldRule}>
      <FormSelect
        <TForm>
        field={field('typeOfPerson')}
        labelKey="declaration.p5.typeOfPerson"
        options={TYPE_OF_PERSON_OPTIONS}
        type="sync"
        fieldRule={fieldRule}
      />
    </FormField>
  )
}

TypeOfPerson.defaultProps = {
  fieldRule: undefined,
}

export default TypeOfPerson
